{
  "brand": "OnBrand Mail",
  "brandTagline": "OnBrand Mail — email signatures, centrally managed.",
  "language": "Language",
  "sampleData": "Sample data",
  "sampleDataHint": "VITE_MOCK_SESSION is on — everything on screen is fixture data.",
  "toggleColorScheme": "Toggle color scheme",
  "switchToLight": "Switch to light mode",
  "switchToDark": "Switch to dark mode",
  "accountMenu": "Account menu",
  "signOut": "Sign out",
  "signIn": "Sign in",
  "retry": "Retry",
  "tryAgain": "Try again",
  "loading": "Loading…",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "edit": "Edit",
  "create": "Create",
  "search": "Search",
  "back": "Back",
  "backToTenant": "Back to tenant",
  "next": "Next",
  "close": "Close",
  "yes": "Yes",
  "no": "No",
  "manage": "Manage",
  "never": "Never",
  "unknown": "Unknown",
  "copy": "Copy",
  "copied": "Copied",
  "refresh": "Refresh",
  "continue": "Continue",
  "confirm": "Confirm",
  "remove": "Remove",
  "add": "Add",
  "open": "Open",
  "download": "Download",
  "upload": "Upload",
  "settings": "Settings",
  "actions": "Actions",
  "status": "Status",
  "name": "Name",
  "email": "Email",
  "description": "Description",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "active": "Active",
  "inactive": "Inactive",
  "none": "None",
  "all": "All",
  "optional": "Optional",
  "required": "Required",
  "any": "Any",
  "done": "Done",
  "reason": "Reason",
  "unknownError": "Unknown error.",
  "apiUnreachableTitle": "The portal could not reach the API",
  "apiUnreachableHint": "In development the API runs on port 5138 and Vite proxies to it. Check that it is running.",
  "signInMicrosoftGoogle": "OnBrand Mail uses your Microsoft or Google work account.",
  "signInGoogle": "OnBrand Mail uses your Google Workspace account.",
  "signInMicrosoft": "OnBrand Mail uses your Microsoft work account.",
  "continueMicrosoft": "Continue with Microsoft",
  "continueGoogle": "Continue with Google",
  "noSignInTitle": "No sign-in configured",
  "noSignInBody": "This deployment has no identity provider yet. An administrator needs to set one up before anybody can sign in.",
  "accessNotGrantedTitle": "Access not yet granted",
  "accessNotGrantedBody": "You are signed in as {{email}}, but no role has been assigned to this account yet. An administrator needs to grant you access before anything is visible.",
  "age": {
    "unknown": "at an unknown time",
    "justNow": "just now",
    "minutesAgo": "{{count}} minutes ago",
    "oneHourAgo": "1 hour ago",
    "hoursAgo": "{{count}} hours ago",
    "oneDayAgo": "1 day ago",
    "daysAgo": "{{count}} days ago"
  }
}
